import { Amplify } from 'aws-amplify';
import { authConfig } from './auth-config';
import logger from "../utils/secureLogger";
export const configureAmplify = () => {
  const config = {
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_QpQyfDXJK',
        userPoolClientId: '6n7nnvvof4ujj17nicbr8mi8g7',
        loginWith: {
          email: true,
          oauth: {
            domain: authConfig.cognitoDomain,
            scopes: authConfig.scopes,
            redirectSignIn: authConfig.redirectSignIn,
            redirectSignOut: authConfig.redirectSignOut,
            responseType: authConfig.responseType,
            providers: [authConfig.samlProvider]
          }
        }
      }
    }
  };

  Amplify.configure(config);
  
  logger.debug('🔧 Amplify configured with Okta SAML integration');
  logger.debug('🏢 SAML Provider:', authConfig.samlProvider);
  logger.debug('🌐 Cognito Domain:', authConfig.cognitoDomain);
  logger.debug('🔄 Redirect URLs:', authConfig.redirectSignIn);
};
